import { trans } from "@mongez/localization";

/**
 * Mock data for subsidiaries
 * This should be replaced with actual data from API/CMS
 */
export const subsidiariesData = [
  {
    name: "zamilSteelHolding",
    capital: "sar250Million",
    ownership: "100%",
    activism: "holdings",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [
      {
        name: "zamilSteelPreEngineeredBuildings",
        capital: "sar50Million",
        ownership: "100%",
        activism: "steelBuildings",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilStructuralSteel",
        capital: "sar75Million",
        ownership: "100%",
        activism: "structuralSteel",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilTowersAndGalvanizing",
        capital: "sar10Million",
        ownership: "100%",
        activism: "transmissionTowers",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilProcessEquipment",
        capital: "sar55Million",
        ownership: "100%",
        activism: "processEquipment",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilInspectionAndMaintenance",
        capital: "sar2Million",
        ownership: "100%",
        activism: "inspectionMaintenance",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "metallicConstructionAndContracting",
        capital: "egp250Thousand",
        ownership: "100%",
        activism: "steelBuildings",
        country: "egypt",
        state: "egypt",
      },
    ],
  },
  {
    name: "advancedBuildingSolutions",
    capital: "sar12Million",
    ownership: "100%",
    activism: "buildingsConstruction",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [],
  },
  {
    name: "zamilAirConditionersHolding",
    capital: "sar1Million",
    ownership: "100%",
    activism: "holdings",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [
      {
        name: "zamilAirConditionersAndHomeAppliances",
        capital: "sar173Million",
        ownership: "100%",
        activism: "airConditioners",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilCentralAirConditioners",
        capital: "sar101Million",
        ownership: "100%",
        activism: "airConditioners",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilAirConditioningAndRefrigerationServices",
        capital: "sar35.7Million",
        ownership: "100%",
        activism: "maintenanceServices",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "ikhtebar",
        capital: "sar500Thousand",
        ownership: "100%",
        activism: "hvacTesting",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "easternDistrictCooling",
        capital: "sar1Million",
        ownership: "100%",
        activism: "districtCooling",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilEnergyServices",
        capital: "sar1Million",
        ownership: "100%",
        activism: "technicalEngineering",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "zamilAirConditioningAndRefrigerationServicesBahrain",
        capital: "bhd270Thousand",
        ownership: "100%",
        activism: "maintenanceServices",
        country: "bahrain",
        state: "bahrain",
      },
    ],
  },
  {
    name: "arabianStonewoolInsulation",
    capital: "sar10Million",
    ownership: "100%",
    activism: "stonewoolInsulation",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [
      {
        name: "secondInsulation",
        capital: "sar50Thousand",
        ownership: "100%",
        activism: "marketingInsulation",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "saudiPreinsulatedPipesIndustries",
        capital: "sar72Million",
        ownership: "51%",
        activism: "preInsulatedPipes",
        country: "saudiArabia",
        state: "saudiArabia",
      },
    ],
  },
  {
    name: "gulfInsulationGroup",
    capital: "sar100Million",
    ownership: "51%",
    activism: "insulationMaterials",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [
      {
        name: "saudiRockWoolFactory",
        capital: "sar40Million",
        ownership: "100%",
        activism: "insulationMaterials",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "arabianFiberglassInsulation",
        capital: "sar25Million",
        ownership: "100%",
        activism: "fiberglassMaterials",
        country: "saudiArabia",
        state: "saudiArabia",
      },
      {
        name: "buildingComponentSolutions",
        capital: "sar25Million",
        ownership: "100%",
        activism: "insulationPanels",
        country: "saudiArabia",
        state: "saudiArabia",
      },
    ],
  },
  {
    name: "zamilSteelBuildings",
    capital: "egp100Million",
    ownership: "100%",
    activism: "steelBuildings",
    country: "egypt",
    state: "egypt",
    subsidiaries: [],
  },
  {
    name: "zamilSteelBuildingsShanghai",
    capital: "rmb12.5Million",
    ownership: "100%",
    activism: "steelBuildings",
    country: "china",
    state: "china",
    subsidiaries: [],
  },
  {
    name: "zamilSteelBuildingsIndia",
    capital: "inr8861Million",
    ownership: "100%",
    activism: "steelBuildings",
    country: "india",
    state: "india",
    subsidiaries: [],
  },
  {
    name: "zamilSteelEngineeringIndia",
    capital: "inr512Million",
    ownership: "100%",
    activism: "engineeringOffice",
    country: "india",
    state: "india",
    subsidiaries: [],
  },
  {
    name: "zamilIndustrialInvestment",
    capital: "aed5Million",
    ownership: "100%",
    activism: "holdings",
    country: "uae",
    state: "uae",
    subsidiaries: [],
  },
  {
    name: "zamilStructuralSteelEgypt",
    capital: "usd10Million",
    ownership: "100%",
    activism: "structuralSteel",
    country: "egypt",
    state: "egypt",
    subsidiaries: [],
  },
  {
    name: "zamilConstructionIndia",
    capital: "inr43.7Million",
    ownership: "100%",
    activism: "projectManagement",
    country: "india",
    state: "india",
    subsidiaries: [],
  },
  {
    name: "zamilInformationTechnologyGlobal",
    capital: "inr23.5Million",
    ownership: "100%",
    activism: "informationTechnology",
    country: "india",
    state: "india",
    subsidiaries: [],
  },
  {
    name: "zamilHigherInstituteForIndustrialTraining",
    capital: "sar814Million",
    ownership: "100%",
    activism: "industrialTraining",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [],
  },
  {
    name: "zamilAirConditionersIndia",
    capital: "inr3363.73Million",
    ownership: "100%",
    activism: "airConditioners",
    country: "india",
    state: "india",
    subsidiaries: [],
  },
  {
    name: "saudiCentralEnergy",
    capital: "sar1Million",
    ownership: "100%",
    activism: "coolingProjectManagement",
    country: "saudiArabia",
    state: "saudiArabia",
    subsidiaries: [],
  },
  {
    name: "zamilIndustrialInvestmentAsia",
    capital: "sgd1",
    ownership: "100%",
    activism: "holdings",
    country: "singapore",
    state: "singapore",
    subsidiaries: [],
  },
  {
    name: "zamilSteelBuildingsVietnam",
    capital: "usd13.2Million",
    ownership: "100%",
    activism: "steelBuildings",
    country: "vietnam",
    state: "vietnam",
    subsidiaries: [],
  },
];

/**
 * Type definitions for subsidiary data
 */
export interface SubsidiaryCompany {
  name: string;
  capital: string;
  ownership: string;
  activism: string;
  country: string;
  state: string;
  subsidiaries: SubsidiaryItem[];
}

export interface SubsidiaryItem {
  name: string;
  capital: string;
  ownership: string;
  activism: string;
  country: string;
  state: string;
}
